import { useEffect, useState } from "react";

export function useOneTrustLoaded() {
  const [oneTrustLoaded, setOneTrustLoaded] = useState<boolean>(false);

  useEffect(() => {
    let attemptCount = 0;
    let cancelled = false;
    let timeoutId: number | undefined;

    const checkLoaded = () => {
      if (cancelled) return;
      if (typeof window !== "undefined" && window.Optanon?.ToggleInfoDisplay) {
        setOneTrustLoaded(true);
      } else if (attemptCount < 4) {
        attemptCount += 1;
        timeoutId = window.setTimeout(checkLoaded, 1000);
      }
    };

    checkLoaded();

    return () => {
      cancelled = true;
      if (timeoutId !== undefined) window.clearTimeout(timeoutId);
    };
  }, []);

  return oneTrustLoaded;
}
